import React, { FC } from 'react';
import { Tab, useTranslate } from 'react-admin';

import { PaperTabbedShowLayout } from '~/layout';
import TransactionTabWrapper from '~/resources/approvals/components/TransactionTabWrapper';
import TransactionApprovalDetailsTab from '~/resources/approvals/components/TransactionApprovalDetailsTab';
import ContextTab from '~/resources/headTransactions/components/context/ContextTab';
import IntegrationTab from '~/resources/headTransactions/components/integration/IntegrationTab';
import {
  BatchRecordsTab,
  isPayrollParentTransaction,
} from '~/resources/headTransactions/TransactionShow';
import { useGetTransaction } from '~/hooks/headTransactions';
import { useRefreshBatchOnOpen } from '~/hooks/batches';
import { ApprovalCaseDetail } from '~/types/approvalCase';

const l = (key: string): string => `resources.headTransactions.${key}`;

const TransactionApprovalTabs: FC<any> = (props) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const approvalCase = props.record as ApprovalCaseDetail;
  const objectId = approvalCase.objectId;

  const { data: transaction } = useGetTransaction(objectId, { staleTime: Infinity });
  const payrollId = isPayrollParentTransaction(transaction)
    ? transaction?.details?.payroll?.id
    : undefined;
  useRefreshBatchOnOpen(payrollId);

  return (
    <PaperTabbedShowLayout {...props}>
      <Tab label={t('tabs.details')}>
        <TransactionApprovalDetailsTab record={approvalCase} />
      </Tab>
      <Tab label={t('tabs.context')} path='context'>
        <TransactionTabWrapper objectId={objectId} TabContent={ContextTab} />
      </Tab>
      <Tab label={t('tabs.integration')} path='integration'>
        <TransactionTabWrapper objectId={objectId} TabContent={IntegrationTab} />
      </Tab>
      {payrollId && (
        <Tab label={t('tabs.batchRecords')} path='batchRecords'>
          <BatchRecordsTab payrollId={payrollId} />
        </Tab>
      )}
    </PaperTabbedShowLayout>
  );
};

export default TransactionApprovalTabs;
